<template>
  <div class="grid">
    <div class="col-12 md:col-6 field p-fluid">
      <TreeInput
        :label="$t('Form category')"
        v-model="properties.documentCategory"
        :options="documentCategories"
        label-key="title"
        item-key="documentCategoryId"
        model-type="object"
        :model-schema="['title', 'documentCategoryId']"
      />
    </div>
    <div class="col-12 md:col-6 field p-fluid">
      <TreeInput
        :label="$t('Form type')"
        v-model="properties.documentType"
        :options="documentTypes"
        label-key="title"
        item-key="documentTypeId"
        model-type="object"
        :model-schema="['title', 'documentTypeId']"
      />
    </div>
  </div>
</template>

<script>
import TreeInput from "../../../inputs/TreeInput.vue";
import {mapGetters} from "vuex";
import {getNestedList} from "../../../../js/utils";

export default {
  name: "MapFormControlConfiguration",
  components: {TreeInput},
  props: {
    customControl: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      common: "GET_COMMON_DATA",
    }),
    properties() {
      if (!this.customControl.properties) this.customControl.properties = {};
      return this.customControl.properties;
    },
    documentTypes() {
      return getNestedList(
        this.common.documentTypes
          .filter((t) =>
            this?.customControl?.properties?.documentCategory?.documentCategoryId
              ? t.documentCategoryId === this.customControl.properties.documentCategory.documentCategoryId
              : t.documentTypeId >= 0
          )
          .map((x) => ({
            documentTypeId: x.documentTypeId,
            parentDocumentTypeId: x.parentDocumentTypeId,
            documentCategoryId: x.documentCategoryId,
            depth: x.depth,
            title: x.title,
          })),
        "documentTypeId",
        "parentDocumentTypeId",
        undefined,
        0
      );
    },
  },
  data() {
    return {
      documentCategories: [],
    }
  },
  created() {
    this.documentCategories = getNestedList(
      this.common.documentCategories.map((x) => ({
        documentCategoryId: x.documentCategoryId,
        parentDocumentCategoryId: x.parentDocumentCategoryId,
        depth: x.depth,
        title: x.title,
      })),
      "documentCategoryId",
      "parentDocumentCategoryId",
      undefined,
      0
    );
  },
}
</script>

<style scoped lang="scss">

</style>
